import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hero", label: "首页" },
  { href: "#trending", label: "今日热榜" },
  { href: "#featured", label: "精华帖" },
  { href: "#collection", label: "主题精选" },
  { href: "#editor", label: "主编精选" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜大全 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
            <i className="ri-emotion-happy-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold text-foreground-950">吃瓜大全</span>
            <span className="mt-1 text-[10px] tracking-widest text-foreground-500">CHIGUA COLLECTION</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700 whitespace-nowrap transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#subscribe"
            className="ml-2 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-mail-line"></i>
            订阅精选
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-lg border border-background-300/70 text-foreground-800"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-mail-line"></i>
              订阅精选
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}